import { useCallback, useState } from 'react'

export const useStages = () => {
  const [stage, setStage] = useState(0)

  const handlePrevStage = useCallback(() => setStage((stage) => stage - 1), [])
  const handleNextState = useCallback(() => setStage((stage) => stage + 1), [])

  return { stage, handlePrevStage, handleNextState }
}
